import { ISearchParamName, ISearchParamNameAndValue, SearchParamName } from '@cbridge-packages/routing';

export namespace SearchParam {
  export const name: ISearchParamName = {
    name: SearchParamName.Search,
  };

  export function nameAndValue(value: ISearchParamNameAndValue['value']): ISearchParamNameAndValue {
    return {
      ...name,
      value,
    };
  }
}
